import { RepositoryFactory } from '../repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from '../services/CredentialsService.js'

const LocationRepository = RepositoryFactory.get('location')

class RiderService {
  static async getLocations (params) {
    try {
      return await LocationRepository.getLocations(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }
}

export default RiderService
